import React from "react";
import { useInView } from "react-intersection-observer";
import { useSearchParams } from "react-router-dom";
import ContactForm from "../components/ContactForm";
import { useContactForm } from "../hooks/useContactForm";
import { typography, spacing } from "../styles/designSystem";
import { IN_VIEW_OPTIONS } from "../styles/animations";
import { serviceCategories } from "../data/servicesData";

const ContactPage = () => {
  const [searchParams] = useSearchParams();
  const requestedService = searchParams.get("service") || "";
  const selectedService = Object.prototype.hasOwnProperty.call(
    serviceCategories,
    requestedService,
  )
    ? requestedService
    : "";

  const { formData, status, handleChange, handleSubmit } = useContactForm({
    name: "",
    email: "",
    phone: "",
    service: selectedService,
    budget: "",
    referralSource: "",
    message: "",
  });

  const { ref, inView } = useInView(IN_VIEW_OPTIONS);

  return (
    <main className="relative min-h-screen overflow-hidden bg-white pt-24 md:pt-32">
      <div className="absolute inset-0 bg-[url('../public/images/bg-consulting-agency.jpg')] bg-cover bg-center" />

      <div className="absolute inset-0 bg-gradient-to-br from-black/85 via-black/75 to-gray-950/80" />

      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black/60 via-black/0 to-transparent" />

      <section
        id="contact-page"
        ref={ref}
        className={`relative z-10 text-white ${spacing.section}`}
      >
        <div className={spacing.container}>
          <div
            className={`grid items-start transition-all duration-1000 ease-out lg:grid-cols-[1fr,1.2fr] ${spacing.cardGap} ${
              inView ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"
            }`}
          >
            <div className="space-y-6">
              <p className={`${typography.label} text-white/60`}>
                Get in touch
              </p>

              <h1 className={`${typography.heading.h1} text-white`}>
                Let's talk about your{" "}
                <span className="text-accent">next project</span>
              </h1>

              <div className="h-1 w-16 rounded-full bg-gradient-to-r from-primary to-accent" />
            </div>

            <div className="sticky top-32">
              <ContactForm
                formData={formData}
                status={status}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                variant="full"
              />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;
